import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from './authContext'
import Swal from 'sweetalert2'

function RequirePerm({ perm, label, children }: { perm: string; label: string; children: React.ReactNode }) {
    const { userProfile } = useAuth()
    const navigate = useNavigate()
    const [allowed, setAllowed] = useState(false)

    useEffect(() => {
        const hasPermission = (userProfile as any)?.[perm] === 1
        if (!hasPermission) {
            Swal.fire({
                title: 'ไม่มีสิทธิ์',
                text: 'สิทธิ์ของท่านไม่สามารถ' + label + 'ได้',
                icon: 'warning',
                confirmButtonText: 'ตกลง',
            }).then(() => {
                navigate('/home', { replace: true })
            })
        } else {
            setAllowed(true)
        }
    }, [userProfile, perm, label, navigate])

    if (!allowed) return null

    return <>{children}</>
}

export default RequirePerm
